import { useCallback, useEffect, useState } from 'react'

import { fetchPublicPlansCatalog, getCachedPublicPlansCatalog } from '../../../services/publicPlansCatalog'

export function usePublicPlans() {
  const [plans, setPlans] = useState(() => getCachedPublicPlansCatalog() || [])
  const [isLoading, setIsLoading] = useState(() => !getCachedPublicPlansCatalog())
  const [fetchError, setFetchError] = useState(null)

  useEffect(() => {
    const cached = getCachedPublicPlansCatalog()
    if (cached) {
      setPlans(cached)
      setIsLoading(false)
      return
    }
    let cancelled = false
    setIsLoading(true)
    fetchPublicPlansCatalog()
      .then(({ plans: nextPlans, error }) => {
        if (cancelled) return
        setPlans(nextPlans)
        setFetchError(error)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const refetch = useCallback(async () => {
    setIsLoading(true)
    setFetchError(null)
    try {
      const { plans: nextPlans, error } = await fetchPublicPlansCatalog({ force: true })
      setPlans(nextPlans)
      setFetchError(error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { plans, isLoading, fetchError, refetch }
}

export default usePublicPlans
